import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a89705d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ミュート", -1))
const _hoisted_2 = {
  key: 0,
  class: "muted-office-list p-3"
}
const _hoisted_3 = {
  key: 0,
  class: "p-3 bg-white text-size-14 text-center"
}

import Header from "@/components/organisms/common/Header.vue";
import AppFooter from "@/components/organisms/common/AppFooter.vue";
import { accountService } from "@/app/services/AccountService";
import { onBeforeMount } from "vue";
import { ref } from "vue";
import { WorkerMuteOffice } from "@/types/worker/WorkerMuteOffice";
import OfficeCard from "@/components/organisms/office/OfficeCard.vue";
import OfficeMuteButton from "@/components/organisms/common/OfficeMuteButton.vue";
import OfficeMuteModal from "@/components/organisms/common/OfficeMuteModal.vue";
import { useLoader } from "@/utils/loader";
import { useErrorModal } from "@/utils/modal";
import { useRouter } from "vue-router";
import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";
import { useToast } from "@/utils/toast";
import { computed } from "vue";
import { orderStore } from "@/store/order";


export default /*#__PURE__*/_defineComponent({
  __name: 'MuteList',
  setup(__props) {

const loader = useLoader();
const errorModal = useErrorModal();
const router = useRouter();
const toast = useToast();

const mutedOffices = ref<WorkerMuteOffice[]>([]);
const isShownMutedOfficeModal = ref(false);
const selectedOfficeIndex = ref<number | null>(null);
const initialized = ref(false);

onBeforeMount(async () => {
  loader.show();
  try {
    await fetchMutedOffices();
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    initialized.value = true;
    loader.hide();
  }
});

const selectedOfficeName = computed(() => {
  if (selectedOfficeIndex.value === null) {
    return "";
  }
  return mutedOffices.value[selectedOfficeIndex.value].office.name;
});

async function fetchMutedOffices() {
  const { results } = await accountService.fetchMutedOffices({
    isMuted: true,
    ordering: "-updated_at"
  });
  mutedOffices.value = results;
}

async function updateMutedOffice({
  index,
  reason
}: {
  index: number;
  reason?: string;
}) {
  loader.show();
  try {
    const mutedOffice = mutedOffices.value[index];
    const isMutedBeforeUpdate = mutedOffice.isMuted; // 変更前にミュート状態ならtrue
    await accountService.updateMutedOffice({
      officeId: mutedOffice.office.id,
      isMuted: !mutedOffice.isMuted,
      reason
    });
    const newMutedOffices = mutedOffices.value.slice();
    newMutedOffices.splice(index, 1, {
      ...mutedOffice,
      isMuted: !isMutedBeforeUpdate
    });
    mutedOffices.value = newMutedOffices;
    toast.toast(
      isMutedBeforeUpdate
        ? "事業所のミュートを解除しました"
        : "事業所をミュートしました",
      {
        toastClass: ["toast-custom", "toast-custom-thin-header-page"],
        toaster: "b-toaster-top-full",
        autoHideDelay: 2000
      }
    );

    // ミュート解除時にキャッシュが残っている場合、
    // ミュートを解除したのに案件一覧に案件が表示されなくなってしまうため、キャッシュをクリアする
    if (isMutedBeforeUpdate) {
      orderStore.clearLimitedOrderListCache();
      orderStore.clearLimitedOrderListCountCache();
    }
  } catch (e) {
    await errorModal.showErrorModal(e as Error);
  } finally {
    loader.hide();
  }
}

async function onClickMuteButton(index: number) {
  const mutedOffice = mutedOffices.value[index];
  if (mutedOffice.isMuted) {
    await updateMutedOffice({ index });
    return;
  }
  selectedOfficeIndex.value = index;
  isShownMutedOfficeModal.value = true;
}

async function onSubmitMuteOfficeModal({ reason }: { reason: string }) {
  await updateMutedOffice({ index: selectedOfficeIndex.value!, reason });
  onCloseMuteOfficeModal();
}

function onCloseMuteOfficeModal() {
  isShownMutedOfficeModal.value = false;
  selectedOfficeIndex.value = null;
}

function onClickBack() {
  router.back();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Header, null, {
      left: _withCtx(() => [
        _createVNode(FeatherIcon, {
          icon: "chevron-left",
          onClick: onClickBack
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(),
        _hoisted_1
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    (initialized.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mutedOffices.value, (mutedOffice, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: mutedOffice.id
            }, [
              _createVNode(OfficeCard, {
                office: mutedOffice.office
              }, {
                default: _withCtx(() => [
                  _createVNode(OfficeMuteButton, {
                    isMuted: mutedOffice.isMuted,
                    onClick: ($event: any) => (onClickMuteButton(index))
                  }, null, 8, ["isMuted", "onClick"])
                ], undefined, true),
                _: 2
              }, 1032, ["office"])
            ]))
          }), 128)),
          _createTextVNode(),
          (mutedOffices.value.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "\n          ミュートリストに登録された事業所はありません\n        "))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    _createVNode(AppFooter),
    _createTextVNode(),
    _createVNode(OfficeMuteModal, {
      isShown: isShownMutedOfficeModal.value,
      officeName: selectedOfficeName.value,
      onSubmit: onSubmitMuteOfficeModal,
      onCancel: onCloseMuteOfficeModal
    }, null, 8, ["isShown", "officeName"])
  ]))
}
}

})